import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/SignInUp.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useToast } from '../ToastContext';
import ReactGA from 'react-ga4';

function SignIn({ setLoggedIn }) {
  const API_URL = process.env.REACT_APP_API_URL;

  const { showToast } = useToast();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_URL}/users/login`, { email, password })

      if (response.data && response.data.id && response.status === 200) {
        //GA
        ReactGA.event({
          category: 'User',
          action: 'login',
          label: 'Logowanie użytkownika'
        });

        localStorage.setItem('userId', response.data.id);
        showToast("Zalogowano!", "success");
        localStorage.setItem("userEmail", response.data.email);
        setLoggedIn(true);
        navigate("/globus");
      }

    } catch (error) {
      console.error("Błąd logowania: ", error);
      if (error.response && error.response.status === 401) {
        showToast("Nieprawidłowe login lub hasło", "error");
        return;
      } else {
        showToast("Wystąpił błąd podczas logowania. Spróbuj ponownie później.", "error")
        return;
      }
    }
  }

  return (
    <div className="register-wrapper">
      <div className="register-card">
        <h2 className="register-title">
          Zaloguj się do TRADI<span className="logo-highlight">WORLD</span>
        </h2>
        <p className="register-subtitle">Witaj ponownie! Kontynuuj swoją podróż.</p>

        <form onSubmit={handleLogin} className="register-form">
          <div className="input-group">
            <label htmlFor="email">Adres e-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="twoj@email.com"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Hasło</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="register-button">
            Zaloguj się
          </button>
        </form>

        <p className="register-footer">
          Nie masz jeszcze konta? <Link to="/rejestracja">Zarejestruj się</Link>
        </p>
        <p>
          <Link to="/reset-hasla">Zresetuj hasło</Link>
        </p>

      </div>
    </div>
  );
}

export default SignIn;